const node_env =  process.env.REACT_APP_NODE_ENV;

switch (node_env) {
  case "prod":
    var environnement = {id:100, label:'- Serveur de production -', color:'info'};
    break;
  case "preprod":
    var environnement = {id:200, label:'- Serveur de test -', color:'warning'};
    break;
  default:
    var environnement = {id:300, label:'- Serveur de dev -', color:'info'};
}

export default environnement
